import { useUserContext } from '@common/context/user';
import { Avatar } from '@konova/ui/avatar';
import { Button } from '@konova/ui/button';
import clsx from 'clsx';
import { FC, useMemo } from 'react';
import classes from './profile-button.module.scss';

export type ProfileButtonProps = {
  onClick?: () => void;
};

/**
 * ProfileButton component displays the user's profile information, including their initials and full name. It is designed to be used in the application's header or navigation bar. The component checks if the user is anonymous and only renders the profile information if the user is authenticated.
 */
export const ProfileButton: FC<ProfileButtonProps> = ({ onClick }) => {
  const { isAnonymous, spaceUser } = useUserContext();

  const initials = useMemo(() => {
    return `${spaceUser?.firstname?.substring(0, 1)} ${spaceUser?.lastname?.substring(0, 1)}`;
  }, [spaceUser]);

  if (isAnonymous) {
    return null;
  }

  return <>
    <Avatar
      data-testid="profile-avatar-button"
      className={clsx(classes.root, classes.avatar)} initials={initials} onClick={onClick} />
    <Button variant={'text'}
      onClick={onClick}
      data-testid="profile-button"
      className={clsx(classes.root, classes.button)}
      classes={{ label: classes.buttonlabel }}>
      {spaceUser?.firstname && spaceUser?.lastname ? `${spaceUser?.firstname || ''} ${spaceUser?.lastname || ''}` : spaceUser?.nickname}
    </Button>
  </>;
};